module.exports = __webpack_public_path__ + "img/Picture1.752a3b99.png";